export default "__VITE_ASSET__By4eXT8A__"